<template>
<div class="row h-100 no-gutters" style="background-color:white;">
    <div class="auth-form mx-auto col-md-12 col-lg-12">
        <div class="my-auto">
            <div class="header-Panel btn-accent">
                <div class="s1 cursor-pointer" style="padding:25px" @click="about()">
                    <strong class="color-blue">About</strong>
                </div>

                <div class="s1 cursor-pointer" style="padding:25px" @click="ContactAs()">
                    <strong class="color-blue">Contact As</strong>
                </div>
                <div class="s1 cursor-pointer" style="padding:25px" @click="Register()">
                    <strong class="color-blue">Register</strong>
                </div>
                <div class="s1 cursor-pointer" style="padding:25px" @click="Login()">
                    <strong class="color-blue">Login</strong>
                </div>

                <img id="main-logo" class="d-inline-block align-top mr-1" style="max-width: 80px;" src="@/assets/images/logo.png" alt="Dev Tool">
                <label style="padding:20px;padding-left:1px; font-weight:500; font-size:20px !important;"> Dev Tool </label>
            </div>
            <div class="card-body  h-100 row my-auto" style="background-color:white;">
                <div class="col-md-8 col-lg-8 my-auto mx-auto" style="padding:10px">
                <center>
                    <img id="main-logo" class="d-inline-block align-top mr-1" style="max-width: 250px;" src="@/assets/images/logoblue.jpg" alt="Dev Tool">
                    <h2>About</h2>
                        <p style="font-size:20px"> Dev Tool is a Agro Trading company. The company includes each one of you. As a member of Dev Tool, you are supposed to Invest our company. We are sure that each of your Income direct impact on your Bank. which we trade for your investment . Not only will you get a platform to be recognized but you will also be maximum amount of profit in terms of money. So get ready. Let’s change the world.
                        </p>
                    </center>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>

import Utilities from '@/Utilities/Utilities';
import backgroundUrl from '@/assets/images/img.jpg'

import axios from 'axios';
export default {
    name: 'Home',
    data() {
        return {
            backgroundUrl,
            Home: {
                PageType: 'Master', // Master, Transaction, Dashboard, Tabb edDashboard
                PageLoad: true, // block/none
                DataModel: {
                    Data: {
                        UserId: 0,
                        UserName: null,
                        Password: null,
                        CreatedBy: null
                    },
                    UIData: {

                    },
                },
                PageState: 'Default', // Default, Changed/Dirty, Submitted, PageLoading Dirty means some values are changed in the page
                TabInfo: {
                    SelectedTabIndex: 0,
                    NumberOfTabs: 0,
                },
                SessionInfo: {
                    SessionTimeout: false,
                    AuthToken: '',
                    SessionID: '',
                    PageInfo: {
                        ClientId: 0,
                        userId: 0,
                        WareHouseId: 0,
                    },
                },
                GridInfo: {},
                Events: {
                    EventRaised: 'Submitted', // Saved, Submitted, Cancelled, AutoCompletionTextChanged,
                    PageToNavigateWhenSubmitted: '', // We can go back to dashboard or stay on the Same page or to a specific page
                },
                ValidationInfo: {},
                ErrorInfo: [{
                    ErrorID: 1,
                    ErrorName: '',
                    ErrorMessage: '',
                }],
                Masters: {},
                Modal: {},
                CharRestrict: {},
            },
        };
    },
    mounted() {},
    methods: {
       about(){
        Utilities.gotoRoute(this, "/About");
      },
      ContactAs(){
        Utilities.gotoRoute(this, "/ContactAs");
      },
      Register(){
        Utilities.gotoRoute(this, "/Registration");
      },
      Login(){
        Utilities.gotoRoute(this, "/Login");
      }

    },
};
</script>

<style scoped>
.header-Panel {
    /* background-color:#00ff9c ; */
    /* #00ff9c */
}

.h-80 {
    height: 87.5% !important;

}

/* <img src="/img/0.73476783.jpg"> */
</style>
